<template>
  <div>
    <p v-if="value && value.html" v-html="value.html" />

    <p v-else-if="value">
      {{ value }}
    </p>
  </div>
</template>

<script>
// @vuese
// Komponent do wyświetlania zawartości html (jeżeli jest takie pole), lub samej zawartości
// @group helpers
export default {
  props: {
    // Wartość do wyświetlania
    value: {
      type: [String, Object],
      required: false
    }
  }
};
</script>
